const About = () => {
    return(
        <div>
            <p>Wanna Join</p>
        </div>
    )
}

export default About;